<ca-dialog-header [title]="data.title" [titleElement]="data.titleElement" [context]="data.context"></ca-dialog-header>
@if (data.content) {
    <mat-dialog-content class="whitespace-pre-line" [ngClass]="data.title || data.titleElement ? 'py-0' : 'pb-0'">
        {{ data.content }}
    </mat-dialog-content>
}
@if (data.contentElement) {
    <mat-dialog-content [ngClass]="data.title || data.titleElement ? 'py-0' : 'pb-0'" class="ca-text-lg">
        <ng-container *ngTemplateOutlet="data.contentElement; context: { $implicit: data.context }"></ng-container>
    </mat-dialog-content>
}
@if (data.formElement) {
    <mat-dialog-content [ngClass]="data.title || data.titleElement ? 'py-0' : 'pb-0'">
        <form [formGroup]="form">
            <ng-container *ngTemplateOutlet="data.formElement; context: { $implicit: { form, context: data.context } }"></ng-container>
        </form>
    </mat-dialog-content>
}
<mat-dialog-actions class="dialog-actions py-4 px-6">
    <button
        mat-stroked-button
        class="ca-button ca-button-m"
        (click)="onCancel()"
        data-testid="confirm-dialog-cancel-btn"
        id="pop-up-cancel"
    >
        {{ data.cancelBtn }}
    </button>
    <button
        mat-flat-button
        class="ca-button ca-button-m"
        [disabled]="data.formElement && form.invalid"
        (click)="onConfirm()"
        data-testid="confirm-dialog-confirm-btn"
        id="pop-up-confirm"
    >
        {{ data.confirmBtn }}
    </button>
</mat-dialog-actions>
